// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ViewUI from "view-design";
import "normalize.css/normalize.css";
import "view-design/dist/styles/iview.css";
import GMSInit from "./index";
import "./components/index";
import { Ssologin } from "./common/SsoLogin.js";

// import osconfig from './os.config.js';
Vue.use(ViewUI);

GMSInit();
//对于开发期全局变量处理
let defaultConfig = {
  product: "default",
  baseUrl: new URL(location.href).origin + new URL(location.href).pathname
};
if (!window.osConfig) {
  window.osConfig = defaultConfig;
} else {
  window.osConfig = Object.assign(defaultConfig, window.osConfig);
}
var windowHref = new URL(window.location.href.replace("#/", ""));
// async function isLogin() {
//   const [checkError, checkLoginData] = await GMS.util.to(GMS.util.checkLogin());
//   const [tgtError, tgtLoginData] = await GMS.util.to(GMS.util.checkTGT());
//   let mypromise = new Promise((resolve, reject) => {
//     if (checkLoginData && tgtLoginData) {
//       resolve(true);
//     } else if (
//       (checkError && checkError.response.status == "302") ||
//       !tgtError
//     ) {
//       reject(checkError);
//     }
//   });
//   return mypromise;
// }

if (windowHref.search) {
  Ssologin.ticketLogin()
    .then(ssores => {
      if (ssores) {
        GMS.util.nros
          .getPlugin("http")
          .get("/nvwa/getLoginContext")
          .then(res => {
            GMS.userContext = res.data.context;
            GMS.util.nros.getPlugin("event").emit("set-user-success");
            GMS.vbus.$emit("logininfo", res.data.context);
            let path = sessionStorage.getItem("topath");
            if (path) {
              router.push(path);
              sessionStorage.removeItem("topath");
            }
          });
      }
    })
    .catch(error => {
      if (!router.currentRoute.query.guid) {
      } else {
        GMS.$http
          .post(
            `/portal/cms/checkPrivileges?guid=` +
              router.currentRoute.query.guid,
            {
              userName: JSON.parse(sessionStorage.getItem("person"))
            }
          )
          .then(value => {
            if (value.status == 200) {
              let Modal = value.data;
              console.log("Modal:", Modal);
              if (!Modal) {
                sessionStorage.setItem("topath", router.currentRoute.fullPath);
                router.push("/login");
              } else {
              }
            }
          });
      }
    });
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js